import axiosInstance from './axiosInstance';

export interface NotificationDto {
  notificationId: number;
  notificationTypeId: number;
  userId: number;
  title: string;
  message: string;
  relatedEntityType?: string;
  relatedEntityId?: number;
  isRead: boolean;
  readDate?: string;
  priority: string;
  createdDate: string;
  expiryDate?: string;
  notificationType?: {
    typeCode: string;
    typeName: string;
    typeNameAr: string;
    category: string;
  };
}

export interface SignalRNotificationPayload {
  notificationId: number;
  title: string;
  titleAr: string;
  message: string;
  messageAr: string;
  priority: string;
  relatedEntityType?: string;
  relatedEntityId?: number;
  createdDate: string;
  isRead: boolean;
}

export const notificationsService = {
  getAll: async (isRead?: boolean, limit = 50): Promise<NotificationDto[]> => {
    const params: Record<string, string> = { limit: limit.toString() };
    if (isRead !== undefined) params.isRead = isRead.toString();
    const response = await axiosInstance.get('/notifications', { params });
    return response.data;
  },

  getUnreadCount: async (): Promise<number> => {
    const response = await axiosInstance.get('/notifications/unread-count');
    return response.data.count;
  },

  markAsRead: async (id: number): Promise<void> => {
    await axiosInstance.post(`/notifications/${id}/mark-read`);
  },

  markAllAsRead: async (): Promise<void> => {
    await axiosInstance.post('/notifications/mark-all-read');
  },

  delete: async (id: number): Promise<void> => {
    await axiosInstance.delete(`/notifications/${id}`);
  },

  deleteAllRead: async (): Promise<void> => {
    await axiosInstance.delete('/notifications/read');
  },
};
